<script>
import useSharedData from "@/use/SharedData";
import {usePaySlipAnnexStore} from "@/stores/PaySlipAnnex";
import useTools from "@/use/Tools";
import useSharedMethod from "@/use/SharedMethod";
import {onMounted, ref} from "vue";
import axios from "axios";
import {usePaySlipStore} from "@/stores/PaySlip";

export default {
    setup() {
        const {dialog, loading, overlay} = useSharedData();
        const paySlipStore = usePaySlipStore();
        const paySlipAnnexStore = usePaySlipAnnexStore();
        const {$route} = useTools();
        const {getBack} = useSharedMethod();
        const annex = ref({});

        function findById(id) {
            loading.value = true;
            axios.get(`/paySlipAnnexes/${id}`).then(response => {
                annex.value = response.data;
            }).finally(() => {
                loading.value = false;
            });
        }

        function close() {
            loading.value = true;
            axios.put(`/paySlipAnnexes/close/${annex.value.id}`).then(response => {
                paySlipAnnexStore.updatePaySlipAnnex(response.data);
                paySlipStore.paySlips.forEach(paySlip => {
                    paySlip.close = true;
                });
                getBack();
            }).finally(() => {
                loading.value = false;
            });
        }

        onMounted(() => findById($route.params.id));

        return {
            annex,
            dialog,
            loading,
            close,
            overlay,
            getBack,
        }
    },
};
</script>

<template>
    <v-dialog
        v-model="dialog"
        persistent scrollable
        max-width="600"
    >
        <v-card flat>
            <w-dialog-toolbar lock-action/>
            <w-overlay
                :loading="loading"
                :overlay="overlay"
                lock-action
                @lock="close"
                @cancel="overlay = false"
            />
            <v-card-text>
                <v-row align="center" justify="center" style="height: 200px;">
                    <h2 class="text-center">
                        {{ $t('pay_slip.ask_for_close') }}
                        <span>{{ annex.name }}</span>
                    </h2>
                </v-row>
            </v-card-text>
            <v-divider/>
            <v-card-actions>
                <v-spacer/>
                <w-btn-close @press="getBack"/>
                <w-btn-lock
                    show
                    :loading="loading"
                    @press="overlay = true"
                />
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>